import React, { useEffect, useRef } from "react";
import "./PopUpCalificar.css";
import logoZoco from "../../assets/img/Logo-ZOCO-4.png";
import terminalImage from "../../assets/img/Contactanos/square-terminal.png";

const CloseIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.61612 6.61612C7.10427 6.12796 7.89573 6.12796 8.38388 6.61612L15 13.2322L21.6161 6.61612C22.1043 6.12796 22.8957 6.12796 23.3839 6.61612C23.872 7.10427 23.872 7.89573 23.3839 8.38388L16.7678 15L23.3839 21.6161C23.872 22.1043 23.872 22.8957 23.3839 23.3839C22.8957 23.872 22.1043 23.872 21.6161 23.3839L15 16.7678L8.38388 23.3839C7.89573 23.872 7.10427 23.872 6.61612 23.3839C6.12796 22.8957 6.12796 22.1043 6.61612 21.6161L13.2322 15L6.61612 8.38388C6.12796 7.89573 6.12796 7.10427 6.61612 6.61612Z"
      fill="#111420"
    />
  </svg>
);

const PopUpNotificaciones3 = ({ onClose }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  const handleOutsideClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <section>
      <div
        className="modalShadowNotificaciones centrado"
        onClick={handleOutsideClick}
        ref={containerRef}
      >
        <div className="popupmodalbody popupmodalbody--crm">
          <div className="popupmodalinner popupmodalinner--crm popupmodalinner--crm-card">
            <div className="popupmodalimg popupmodalimg--crm popupmodalimg--crm-layout">
              <div className="popupmodalcopy popupmodalcopy--crm">
                <img
                  src={logoZoco}
                  alt="Zoco"
                  className="popupmodalcopy__logo"
                />
                <h2 className="popupmodalcopy__title">
                  Aceptá <strong>tarjetas de débito</strong>
                  <br />
                  y <strong>crédito</strong> con el costo por
                  <br />
                  operación más bajo.
                </h2>
                <div className="popupmodalcopy__cta">
                  Solicitá tu terminal hoy.
                </div>
              </div>

              <div className="popupmodalvisual popupmodalvisual--crm" aria-hidden="true">
                <img
                  src={terminalImage}
                  alt=""
                  className="popupmodalvisual__terminal"
                />
              </div>
            </div>
          </div>

          <div className="popupmodalclosebtn popupmodalclosebtn--crm">
            <button
              className="popupmodalclosebtn-btn"
              onClick={onClose}
              aria-label="Cerrar promocion"
              type="button"
            >
              <CloseIcon />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PopUpNotificaciones3;
